import Footer from "../components/Footer";
import { Button, Card, CardHeader, CardContent, CardFooter } from "@dawa/ui";

const plans = [
  {
    name: "Starter",
    price: "0 € / mois",
    features: ["5 projets", "Support standard", "Accès aux fonctionnalités de base"],
  },
  {
    name: "Pro",
    price: "49 € / mois",
    recommended: true,
    features: [
      "Projets illimités",
      "Support prioritaire",
      "Intégrations avancées",
      "Mises à jour en temps réel",
    ],
  },
  {
    name: "Entreprise",
    price: "Sur devis",
    features: [
      "Solutions sur mesure",
      "Gestionnaire de compte dédié",
      "SLA personnalisé",
      "Support 24/7",
    ],
  },
];

const faqs = [
  {
    q: "Puis-je changer d'offre plus tard ?",
    a: "Oui, vous pouvez mettre à niveau ou rétrograder votre offre à tout moment depuis votre espace client.",
  },
  {
    q: "Proposez-vous une période d'essai ?",
    a: "L'offre Starter est gratuite et vous permet de tester le service sans engagement.",
  },
  {
    q: "L'offre Entreprise inclut-elle une assistance dédiée ?",
    a: "Oui, un gestionnaire de compte dédié est à votre disposition pour vous accompagner.",
  },
];

export default function Pricing() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col p-6">
        <h1 className="mb-8 text-center text-4xl font-bold">Tarifs</h1>
        <div className="grid flex-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {plans.map((plan) => (
            <Card
              key={plan.name}
              className={`relative flex flex-col p-6 transition-transform hover:scale-105 hover:shadow-lg ${plan.recommended ? "border-primary bg-primary/10" : ""}`}
            >
              {plan.recommended && (
                <span className="absolute right-4 top-4 rounded bg-primary px-2 py-1 text-xs font-semibold text-white">
                  Recommandé
                </span>
              )}
              <CardHeader>
                <h2 className="mb-4 text-xl font-semibold">{plan.name}</h2>
                <p className="text-3xl font-bold">{plan.price}</p>
              </CardHeader>
              <CardContent className="flex-1">
                <ul className="mb-6 space-y-2">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start">
                      <span className="mr-2">✅</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
              <CardFooter>
                <Button className="w-full">Choisir cette offre</Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        <section className="mt-16">
          <h2 className="mb-6 text-center text-2xl font-bold">FAQ</h2>
          <div className="mx-auto max-w-3xl space-y-4">
            {faqs.map((item) => (
              <details key={item.q} className="rounded-lg border p-4">
                <summary className="cursor-pointer font-medium">{item.q}</summary>
                <p className="mt-2 text-sm text-secondary">{item.a}</p>
              </details>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
